export const sizes = () => {
  const sizeBasic = `
    --size-1: 0.1rem;
    --size-2: 0.2rem;
    --size-3: 0.3rem;
    --size-4: 0.4rem;
    --size-5: 0.5rem;
    --size-6: 0.6rem;
    --size-7: 0.7rem;
    --size-8: 0.8rem;
    --size-9: 0.9rem;

    --size-10: 1rem;
    --size-11: 1.1rem;
    --size-12: 1.2rem;
    --size-13: 1.3rem;
    --size-14: 1.4rem;
    --size-15: 1.5rem;
    --size-16: 1.6rem;
    --size-18: 1.8rem;
    
    --size-20: 2.0rem;
    --size-22: 2.2rem;
    --size-24: 2.4rem;
    --size-26: 2.6rem;
    --size-28: 2.8rem;
    
    --size-30: 3.0rem;
    --size-32: 3.2rem;
    --size-36: 3.6rem;
    
    --size-40: 4.0rem;
    --size-42: 4.2rem;
    --size-44: 4.4rem;
    
    --size-50: 5.0rem;
    
    --size-60: 6.0rem;
    --size-64: 6.4rem;
    --size-128: 12.8rem;
  `;

  return sizeBasic;
};
